import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { UnitsPropertyManagement } from '../../../routes';

export const UnitsPropertyManagementLayout = () => <SwitchRoute routes={UnitsPropertyManagement} />;
